import React, { useEffect, useState } from "react";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import { Box, IconButton, List, Typography } from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import ChatIcon from "@mui/icons-material/Chat";
import MenuIcon from "@mui/icons-material/Menu";

export const ChatListNav = ({ toggleDrawer, Chatlist, generate, isOpen }) => {
  const [searchTerm, setSearchTerm] = useState("");

  // chatName is what the user actually sees: the other person for a direct
  // chat, the group name for a group. Search has to match that.
  const visibleChats = Chatlist?.filter((data) =>
    (data.chatName || data.groupName || "")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className={`Chatdrawer ${isOpen ? "open" : ""}`} style={{ zIndex: 10 }}>
      <div className="chat-drawer-header">
        <Typography
          fontFamily={FontFamily.Poppins}
          fontWeight={fontWeight.W600}
          fontSize={fontSize.h3.medium}
          color={"#2F378D"}
        >
          Your Conversation
        </Typography>

        <IconButton
          size="small"
          onClick={toggleDrawer}
          className="chat-drawer-close"
          aria-label="close conversations"
          sx={{ color: "#2F378D" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <input
        type="text"
        className="chat-search-input"
        placeholder="Search chat..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className="chat-list-scroll">
        {visibleChats?.length > 0 ? (
          <List className="w-100" style={{ textAlign: "left", padding: 0 }}>
            {generate(visibleChats, <ChatIcon />)}
          </List>
        ) : (
          <Box
            sx={{
              py: 5,
              px: 1,
              textAlign: "center",
              color: ThemeColor.GREY,
              fontSize: 13,
            }}
          >
            {searchTerm ? "No chat matches your search" : "No conversation yet"}
          </Box>
        )}
      </div>
    </div>
  );
};
